/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IBazzarvoiceWidgetViewProps } from './bazzarvoice-widget';
import Bazzarvoice from './components/Bazzarvoice';

export default (props: IBazzarvoiceWidgetViewProps) => {
    const {
        data: { product },
        config
    } = props;
    const productInfo = product?.result;
    return <Bazzarvoice productInfo={productInfo} widgetType={config.widgetType} />;
};
